/**
 * Created by qlong on 10/4/2016.
 */
import React, {Component} from 'react';
import Filters from '../containers/Filter'
import File from'../containers/File'
import FilterGrid from '../containers/FilterGrid'
import FilterLineChart from '../containers/FilteredLineChart'
const vizJsonData = require('../../data/visualizationLibrary.json');

export default class Visualization extends Component{
    render() {
        let { pathname } = this.props.location
        if (pathname.includes('/')){
            const pathnameArray = pathname.split("/")
            pathname = pathnameArray[pathnameArray.length-1]
        }

        const caption = vizJsonData.visualizations.filter((viz) => (viz.routeName == pathname || pathname == ""))[0].caption
        return (
            <div className="childDiv">
                <div>
                    <div>
                        {caption}
                        <br/><br/>
                    </div>
                </div>
                <File path={pathname} />
                <Filters path={pathname} />
                <FilterLineChart />
                <FilterGrid />
            </div>
        )

    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Visualization.js
 **/